export default {
  APP_VERSION: 'API-AppVersion',
  CORRELATION_ID: 'API-CorrelationId',
  DEVICE_UID: 'API-DeviceUid',
  IPRESSO_CONTACT_HASH: 'API-IpressoContactHash',
  STATS_HASH: 'API-StatsHash',
  SUBSCRIBER_HASH: 'API-SubscriberHash',
  SUBSCRIBER_PUB: 'API-SubscriberPub',
};
